import { parse } from "./rich-text-browser-parser.js";
export { parse as browserParse };
